import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'
import { actionButtonRow } from './style-settings'

/**
 * Row of contained buttons: first stretches (text CTA), following siblings stay compact
 * (e.g. icon-only). Tokens: `actionButtonRow` in `style-settings.ts`.
 */
export const useActionButtonRowStyles = makeStyles((theme: Theme) =>
  createStyles({
    equalWidthRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(1, 1.5),
      alignItems: 'stretch',
      '& > .MuiButton-root': {
        justifyContent: 'center',
        boxSizing: 'border-box',
        borderRadius: actionButtonRow.borderRadius,
        fontWeight: actionButtonRow.fontWeight,
      },
      /** Primary / text action — shares remaining width */
      '& > .MuiButton-root:first-of-type': {
        flex: '1 1 0',
        minWidth: 0,
        maxWidth: '100%',
        minHeight: actionButtonRow.minHeightPx,
        padding: actionButtonRow.padding,
        fontSize: actionButtonRow.fontSize,
      },
    },
  })
)
